import { observer } from 'mobx-react-lite'

import { RefreshButton } from '@/Ship/Components/UI/RefreshButton/RefreshButton'

interface ReloadButtonProps {
    crudContext: any
}

/** «Оновити» журналу: перезавантажує список; іконка крутиться, поки він вантажиться */
export const ReloadButton = observer(({ crudContext }: ReloadButtonProps) => {
    const listContext = crudContext?.listContext
    return (
        <RefreshButton
            onRefresh={() => listContext?.actions?.load?.(true)}
            refreshing={listContext?.isLoading === true}
            label="Оновити"
        />
    )
})
